<template>
  <b-card
    no-body
    class="data-acuan-page p-2 p-md-3 bg-white"
  >
    <!-- Header Title & Back Button -->
    <div class="d-flex align-items-center pb-2 mb-3 border-bottom-subtle">
      <button
        type="button"
        class="btn-back mr-2"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </button>
      <h3 class="page-title m-0">
        Data Acuan
      </h3>
    </div>

    <!-- Filter Card -->
    <div class="filter-card mb-2">
      <label class="filter-label">Provinsi</label>
      <div class="filter-select-wrapper">
        <v-select
          v-model="search"
          label="label"
          placeholder="Cari provinsi"
          :options="listProvince"
          :clearable="false"
          :reduce="data => data.label"
          class="custom-vselect"
          @input="searchArea"
        />
      </div>
    </div>

    <!-- Table Card -->
    <div
      v-if="listArea.length > 0 || loadingData"
      class="table-card-container"
    >
      <b-overlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-100"
        rounded="sm"
      >
        <b-table
          hover
          show-empty
          :items="listArea"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          table-class="custom-acuan-table m-0"
        >
          <template #cell(city)="data">
            <span class="city-name font-medium">
              {{ data.value }}
            </span>
          </template>
          <template #cell(action)="data">
            <div class="d-flex align-items-center justify-content-end action-cell-wrapper">
              <button
                type="button"
                class="btn-details"
                @click="$router.push(`/coverage-area/detail/${data.item.city}?product=${$route.query.product}`)"
              >
                Details
              </button>
              <b-button
                :id="`download-${data.index}`"
                class="btn-action-download"
                variant="plain"
                :disabled="data.item.status === 'onprogress'"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/file-download.svg"
                  alt="download"
                  width="20"
                  height="20"
                >
              </b-button>
              <b-popover
                :target="`download-${data.index}`"
                triggers="hover"
                placement="bottom"
                custom-class="wrapper-shipment"
              >
                <b-list-group>
                  <b-list-group-item
                    v-for="(shipping, idx) in expeditions"
                    :key="idx"
                    class="cursor-pointer text-xs"
                    @click="downloadExcel(data.item.city, shipping)"
                  >
                    {{ shipping }}
                  </b-list-group-item>
                </b-list-group>
              </b-popover>
            </div>
          </template>
        </b-table>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import vSelect from 'vue-select'
import { mapState } from 'vuex'
import { BCard, BPopover } from 'bootstrap-vue'
import { configFieldsSArea, listProvince } from './config'

export default {
  components: { vSelect, BCard, BPopover },
  data() {
    return {
      search: '',
      loadingData: false,
      fields: configFieldsSArea,
      listArea: [],
      listProvince,
      expeditions: [],
    }
  },
  computed: {
    ...mapState('filter', ['expeditionList']),
  },
  mounted() {
    const savedSearch = sessionStorage.getItem('search_province')
    if (savedSearch) {
      this.search = savedSearch
      this.searchArea()
    }
    if (this.expeditionList.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    const defaultExpeditions = [...this.expeditionList, { shipping_name: 'GOSEND' }]
    this.expeditions = defaultExpeditions.filter(item => (this.$route.query.product === 'komship' ? (item.shipping_name !== 'SAP' && item.shipping_name !== 'GOSEND') : item)).map(item => item.shipping_name)
  },
  methods: {
    searchArea() {
      this.loadingData = true
      sessionStorage.setItem('search_province', this.search)
      const params = {
        province: this.search,
        source: this.$route.query.product,
      }
      this.$http_new.get('/komship/api/v1/admin/coverage-area/city-by-province', { params })
        .then(res => {
          const { data } = res.data
          this.listArea = data
          this.loadingData = false
        })
        .catch(err => {
          this.loadingData = false
          this.listArea = []
          this.$toast_error({ message: 'Tidak mendapatkan list kota' })
        })
    },
    downloadExcel(city, shipping) {
      const params = {
        shipping,
        city,
        source: this.$route.query.product,
      }
      this.$http_new.post('/komship/api/v1/admin/coverage-area/city-xls', params)
        .then(res => {
          this.downloadFromBase64(res.data.data.base64_file, city, shipping)
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal mengunduh data' })
        })
    },
    downloadFromBase64(data, city, shipping) {
      const a = document.createElement('a')
      a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`
      a.download = `template_${city}_${shipping}.xlsx`
      a.click()
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.wrapper-shipment > .popover-body {
  padding: 0 !important;
  min-width: 160px;
}
</style>

<style lang="scss" scoped>
.data-acuan-page {
  border-radius: 8px;
  border: none;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.border-bottom-subtle {
  border-bottom: 1px solid #f1f1f4;
}

/* Back Button */
.btn-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
    color: #111827;
  }

  &:focus {
    outline: none;
  }
}

/* Filter Card */
.filter-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px 24px;
}

.filter-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
  display: block;
}

.filter-select-wrapper {
  max-width: 440px;
  width: 100%;
}

/* Custom VSelect */
::v-deep .custom-vselect {
  .vs__dropdown-toggle {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 3px 8px;
    min-height: 40px;
    background-color: #ffffff;
    transition: border-color 0.2s ease;
  }

  &.vs--open .vs__dropdown-toggle {
    border-color: #f95031;
  }

  .vs__selected {
    color: #1f2937;
    font-size: 13px;
  }

  .vs__search {
    font-size: 13px;
    color: #1f2937;
    margin: 4px 0 0 0;
    padding: 0 4px;

    &::placeholder {
      color: #9ca3af;
    }
  }

  .vs__actions {
    padding-top: 0;
  }

  .vs__open-indicator {
    fill: #6b7280;
    transform: scale(0.75);
  }
}

/* Table Card */
.table-card-container {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
}

::v-deep .custom-acuan-table {
  margin-bottom: 0 !important;

  thead th {
    background-color: #f9fafb !important;
    color: #374151 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border-bottom: 1px solid #e5e7eb !important;
    border-top: none !important;
    padding: 14px 24px !important;
    white-space: nowrap;
    text-transform: inherit !important;

    &:last-child {
      text-align: right !important;
    }
  }

  tbody tr {
    background-color: #ffffff;
    transition: background-color 0.15s ease;

    &:hover td {
      background-color: #fafbfc !important;
    }
  }

  tbody td {
    border-bottom: 1px solid #f3f4f6 !important;
    border-top: none !important;
    padding: 14px 24px !important;
    font-size: 13px !important;
    color: #1f2937;
    vertical-align: middle !important;

    &:last-child {
      text-align: right !important;
    }
  }

  tbody tr:last-child td {
    border-bottom: none !important;
  }
}

.city-name {
  color: #1f2937;
  font-weight: 500;
}

/* Action Cell */
.action-cell-wrapper {
  gap: 16px;
}

.btn-details {
  background: transparent;
  border: none;
  padding: 0;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #f95031;
  }

  &:focus {
    outline: none;
  }
}

.btn-action-download {
  background-color: #fff2ea !important;
  border: none !important;
  border-radius: 8px !important;
  width: 32px;
  height: 32px;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  box-shadow: none !important;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #ffe3d3 !important;
    transform: scale(1.05);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.35;
  }

  .action-icon {
    font-size: 18px;
    color: #f95031;
  }
}
</style>
